import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import DrawerHeader from "@components/DrawerHeader";
import LeaderBankDetails from "@screens/BankDetails/LeaderBankDetails";
import BankDetailsGraphic from "@assets/svg/BankDetailsGraphic";

const BankDetails = ({ navigation }) => {
  return (
    <View style={styles.mainContainer}>
      <DrawerHeader headerName="Account Details" />
      <LeaderBankDetails navigation={navigation} />

      <View style={styles.graphicContainer}>
        <BankDetailsGraphic />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    position: "relative",
  },
  graphicContainer: {
    alignSelf: "center",
    bottom: 0,
    position: "absolute",
  },
});

export default BankDetails;
